// extracted by mini-css-extract-plugin
export var scrollArea = "_om-0";